import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

const PageTransition = ({ children, className }: PageTransitionProps) => {
  const location = useLocation();

  return (
    <div
      key={location.pathname}
      className={cn("page-transition", className)}
    >
      {children}
    </div>
  );
};

export default PageTransition;
